import { Box, type BoxProps, type Theme } from "@mui/material";
import { Flex } from "@zfp-akademie-a-s/zfp-design";
import { Spacing } from "Infrastructure/Themes/Themes";

export const DATE_COLUMN_WIDTH = 96;
export const AXIS_COLUMN_WIDTH = 24;

/** A ring in the page colour, so markers cut through the axis line. */
export const axisMarkerRing = (theme: Theme) => ({ boxShadow: `0 0 0 3px ${theme.palette.background.paper}` });

/** Three-column row shared by all timeline items: date | axis | content. */
export const TimelineRow = (props: BoxProps) => (
  <Box display="grid" gridTemplateColumns={`${DATE_COLUMN_WIDTH}px ${AXIS_COLUMN_WIDTH}px minmax(0, 1fr)`} {...props} />
);

export const TimelineDateCell = (props: BoxProps) => <Box pr={Spacing.L} textAlign="right" {...props} />;

export const TimelineAxisCell = ({ children, ...rest }: BoxProps) => (
  <Flex justifyContent="center" {...rest}>
    {children}
  </Flex>
);

export const TimelineContentCell = (props: BoxProps) => <Box pl={Spacing.XL} minWidth={0} {...props} />;
